const SettingsTypes = {
	FETCH_LICENSE: {
		SUCCESS: 'FETCH_LICENSE_SUCCESS',
		FAILURE: 'FETCH_LICENSE_FAILURE',
		PENDING: 'FETCH_LICENSE_PENDING',
	},

	FETCH_CERTIFICATES: {
		SUCCESS: 'FETCH_CERTIFICATES_SUCCESS',
		FAILURE: 'FETCH_CERTIFICATES_FAILURE',
		PENDING: 'FETCH_CERTIFICATES_PENDING',
	},

	FETCH_ORDERS: {
		SUCCESS: 'FETCH_ORDERS_SUCCESS',
		FAILURE: 'FETCH_ORDERS_FAILURE',
		PENDING: 'FETCH_ORDERS_PENDING',
	},

	FETCH_CHECK_SPEECH: {
		SUCCESS: 'FETCH_CHECK_SPEECH_SUCCESS',
		FAILURE: 'FETCH_CHECK_SPEECH_FAILURE',
		PENDING: 'FETCH_CHECK_SPEECH_PENDING',
	},

	DISABLE_MIC: {
		SUCCESS: 'DISABLE_MIC_SUCCESS',
		FAILURE: 'DISABLE_MIC_FAILURE',
		PENDING: 'DISABLE_MIC_PENDING',
	},

	UPDATE_LICENSE: {
		SUCCESS: 'UPDATE_LICENSE_SUCCESS',
		FAILURE: 'UPDATE_LICENSE_FAILURE',
		PENDING: 'UPDATE_LICENSE_PENDING',
	},

	CHECK_NOTIFICATION: {
		SUCCESS: 'CHECK_NOTIFICATION_SUCCESS',
		FAILURE: 'CHECK_NOTIFICATION_FAILURE',
		PENDING: 'CHECK_NOTIFICATION_PENDING',
	},

	TOGGLE_NOTIFICATIONS: {
		SUCCESS: 'TOGGLE_NOTIFICATIONS_SUCCESS',
		FAILURE: 'TOGGLE_NOTIFICATIONS_FAILURE',
		PENDING: 'TOGGLE_NOTIFICATIONS_PENDING',
	},

	SEND_OTP: {
		SUCCESS: 'SEND_OTP_SUCCESS',
		FAILURE: 'SEND_OTP_FAILURE',
		PENDING: 'SEND_OTP_PENDING',
	},

	MERGE_ACCOUNT: {
		SUCCESS: 'MERGE_ACCOUNT_SUCCESS',
		FAILURE: 'MERGE_ACCOUNT_FAILURE',
		PENDING: 'MERGE_ACCOUNT_PENDING',
	},

	HANDLE_INPUT_CHANGE: 'HANDLE_INPUT_CHANGE',
	UPDATE_NOTIFICATION_STATUS: 'UPDATE_NOTIFICATION_STATUS',
	UPDATE_SETTINGS: 'UPDATE_SETTINGS',
};

export default SettingsTypes;
